import React from "react";

export default ({ avatar = "", placeholder, ...modifiers }) => {
  let className = "avatar";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  const imageUrl =
    avatar && avatar.breakpoints
      ? avatar.base_path + avatar.breakpoints.lg["1x"]
      : avatar;
  if (!imageUrl) className += " -noImage";
  return (
    <div className={className} style={{ backgroundImage: `url(${imageUrl})` }}>
      {placeholder}
    </div>
  );
};
